/* Copyright (C) NewFoundry 2021 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _toConsumableArray = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var DEFAULT_MAGNIFY_WINDOW_SIZE = 150;
var CANVAS_MAGNIFICATION = 1;

var Canvas = /*#__PURE__*/function (_react_1$default$Pure) {
  _inherits(Canvas, _react_1$default$Pure);

  var _super = _createSuper(Canvas);

  function Canvas(props) {
    var _this;

    _classCallCheck(this, Canvas);

    _this = _super.call(this, props);
    _this.imgCache = {};
    _this.canvas = react_1.createRef();
    _this.magnifier = react_1.createRef();
    _this.state = {
      isMagnified: false
    };
    _this.drawMagnifer = _this.drawMagnifer.bind(_assertThisInitialized(_this));
    _this.handleMagnifierMove = _this.handleMagnifierMove.bind(_assertThisInitialized(_this));
    _this.handleMagnifierOut = _this.handleMagnifierOut.bind(_assertThisInitialized(_this));
    _this.magnifyOff = _this.magnifyOff.bind(_assertThisInitialized(_this));
    _this.magnifyOn = _this.magnifyOn.bind(_assertThisInitialized(_this));
    _this.setMagnifierPosition = _this.setMagnifierPosition.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Canvas, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _a, magnify;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                magnify = this.props.magnify;

                if (magnify) {
                  this.magnifierCtx = (_a = this.magnifier) === null || _a === void 0 ? void 0 : _a.current.getContext('2d');
                }

                this.addEventListeners([['mousemove', this.handleMagnifierMove], ['mouseout', this.handleMagnifierOut], ['mousedown', this.magnifyOn], ['mouseup', this.magnifyOff], ['mouseout', this.magnifyOff]]);
                _context.next = 5;
                return this.drawImages(this.props);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props = this.props,
          isFullScreen = _this$props.isFullScreen,
          urls = _this$props.urls;
      var newUrls = urls.join('') !== prevProps.urls.join('');

      if (isFullScreen || newUrls) {
        this.drawImages(this.props);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeEventListeners([['mousemove', this.handleMagnifierMove], ['mouseout', this.handleMagnifierOut], ['mousedown', this.magnifyOn], ['mouseup', this.magnifyOff], ['mouseout', this.magnifyOff]]);
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners(events) {
      var _this2 = this;

      events.forEach(function (event) {
        var _this2$canvas$current;

        return (_this2$canvas$current = _this2.canvas.current).addEventListener.apply(_this2$canvas$current, _toConsumableArray(event));
      });
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners(events) {
      var _this3 = this;

      events.forEach(function (event) {
        var _this3$canvas$current;

        return (_this3$canvas$current = _this3.canvas.current).removeEventListener.apply(_this3$canvas$current, _toConsumableArray(event));
      });
    }
  }, {
    key: "arrayEquals",
    value: function arrayEquals(arr1, arr2) {
      return !arr1.some(function (a) {
        return !arr2.includes(a);
      });
    }
  }, {
    key: "drawImages",
    value: function () {
      var _drawImages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(props) {
        var _this4 = this;

        var urls, setIsLoading;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                urls = props.urls, setIsLoading = props.setIsLoading;

                if (setIsLoading && !this.arrayEquals(Object.keys(this.imgCache), urls)) {
                  setIsLoading(true);
                }

                return _context2.abrupt("return", new Promise(function (resolve) {
                  var numLoaded = 0;

                  var drawIfReady = function drawIfReady() {
                    if (++numLoaded >= urls.length) {
                      var canvas = _this4.canvas.current;
                      var ctx = canvas === null || canvas === void 0 ? void 0 : canvas.getContext('2d');

                      if (!ctx) {
                        return;
                      }

                      ctx.clearRect(0, 0, canvas.width, canvas.height);
                      urls.map(function (url) {
                        if (_this4.imgCache[url] && _this4.imgCache[url].complete) {
                          ctx.drawImage(_this4.imgCache[url], -2, 0, canvas.width, canvas.height);
                        }
                      });

                      if (setIsLoading) {
                        setIsLoading(false);
                      }

                      resolve(null);
                    }
                  };

                  urls.map(function (url) {
                    if (_this4.imgCache[url]) {
                      drawIfReady();
                    } else {
                      var imageObj = new Image();

                      imageObj.onload = function () {
                        _this4.imgCache[url] = imageObj;
                        drawIfReady();
                      };

                      imageObj.onerror = function (err) {
                        _this4.imgCache[url] = null;
                        console.log(err);
                        drawIfReady();
                      };

                      imageObj.src = url;
                    }
                  });

                  if (!urls.length) {
                    drawIfReady();
                  }
                }));

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function drawImages(_x) {
        return _drawImages.apply(this, arguments);
      }

      return drawImages;
    }()
  }, {
    key: "magnifyOn",
    value: function magnifyOn(e) {
      var _this$props2 = this.props,
          isFullScreen = _this$props2.isFullScreen,
          magnify = _this$props2.magnify;

      if (!magnify || isFullScreen) {
        return;
      }

      this.setMagnifierPosition(e);
      this.drawMagnifer(e);
      this.setState({
        isMagnified: true
      });
    }
  }, {
    key: "magnifyOff",
    value: function magnifyOff(e) {
      var _this$props3 = this.props,
          isFullScreen = _this$props3.isFullScreen,
          magnify = _this$props3.magnify;

      if (!magnify || isFullScreen) {
        return;
      }

      this.magnifier.current.style.display = 'none';
      this.setState({
        isMagnified: false
      });
    }
  }, {
    key: "drawMagnifer",
    value: function drawMagnifer(e) {
      var _this$props4 = this.props,
          isFullScreen = _this$props4.isFullScreen,
          magnify = _this$props4.magnify;

      if (!magnify || isFullScreen) {
        return;
      }

      var height = this.props.height || this.canvas.current.clientHeight;
      var width = this.props.width || this.canvas.current.clientWidth;
      var magnifyWindowSize = this.props.magnifyWindowSize || DEFAULT_MAGNIFY_WINDOW_SIZE;
      var ratioX = CANVAS_MAGNIFICATION * (width / this.canvas.current.clientWidth);
      var ratioY = CANVAS_MAGNIFICATION * (height / this.canvas.current.clientHeight);
      var canvasY = e.offsetY * ratioY - magnifyWindowSize / 2;
      var canvasX = e.offsetX - magnifyWindowSize / 2;
      this.magnifierCtx.fillStyle = '#fff';
      this.magnifierCtx.fillRect(0, 0, this.magnifier.current.width, this.magnifier.current.height);
      this.magnifierCtx.drawImage(this.canvas.current, canvasX, canvasY, magnifyWindowSize, magnifyWindowSize, 0, 0, magnifyWindowSize, magnifyWindowSize);
    }
  }, {
    key: "setMagnifierPosition",
    value: function setMagnifierPosition(e) {
      var _this$props5 = this.props,
          isFullScreen = _this$props5.isFullScreen,
          magnify = _this$props5.magnify;

      if (!magnify || isFullScreen) {
        return;
      }

      var rect = this.canvas.current.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var y = e.clientY - rect.top;
      var magnifyWindowSize = this.props.magnifyWindowSize || DEFAULT_MAGNIFY_WINDOW_SIZE;
      this.magnifier.current.style.left = "".concat(x - magnifyWindowSize / 2, "px");
      this.magnifier.current.style.top = "".concat(y - magnifyWindowSize / 2, "px");
      this.magnifier.current.style.display = 'block';
    }
  }, {
    key: "handleMagnifierMove",
    value: function handleMagnifierMove(e) {
      if (!this.state.isMagnified) {
        return;
      }

      this.drawMagnifer(e);
      this.setMagnifierPosition(e);
    }
  }, {
    key: "handleMagnifierOut",
    value: function handleMagnifierOut(e) {
      var _this$props6 = this.props,
          isFullScreen = _this$props6.isFullScreen,
          magnify = _this$props6.magnify;

      if (!magnify || isFullScreen) {
        return;
      }

      this.magnifier.current.style.display = 'none';
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          className = _this$props7.className,
          containerCls = _this$props7.containerCls,
          height = _this$props7.height,
          isFullScreen = _this$props7.isFullScreen,
          magnify = _this$props7.magnify,
          magnifierCls = _this$props7.magnifierCls,
          magnifyWindowSize = _this$props7.magnifyWindowSize,
          width = _this$props7.width;
      var isMagnified = this.state.isMagnified;
      var style = {};

      if (magnify && !isFullScreen) {
        style.cursor = isMagnified ? 'none' : 'zoom-in';
      }

      return react_1.default.createElement("div", {
        className: "Canvas__container ".concat(classnames_1.default(containerCls)),
        style: {
          maxHeight: '100%',
          height: '100%',
          position: 'relative'
        }
      }, react_1.default.createElement("canvas", {
        className: "Canvas__primary ".concat(classnames_1.default(className)),
        height: height * CANVAS_MAGNIFICATION,
        width: width * CANVAS_MAGNIFICATION,
        ref: this.canvas,
        style: style
      }), magnify && !isFullScreen && react_1.default.createElement("canvas", {
        className: "Canvas__magnifier ".concat(classnames_1.default(magnifierCls)),
        height: magnifyWindowSize || DEFAULT_MAGNIFY_WINDOW_SIZE,
        width: magnifyWindowSize || DEFAULT_MAGNIFY_WINDOW_SIZE,
        ref: this.magnifier
      }));
    }
  }]);

  return Canvas;
}(react_1.default.PureComponent);

exports.default = Canvas;